import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {capitalize, filter, get, includes, map} from 'lodash';
import Modal from 'shared/components/modal';

import {closeModal} from 'shared/actions/modal';
import {Store} from 'src/types/store';

export const COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL =
  'colleges-not-offering-transfer-term-modal';

const CollegesNotOfferingTransferTermModal = () => {
  const dispatch = useDispatch();

  const show = useSelector(
    (state: Store) => state.modal[COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL] === true
  );

  const collegeLogos = useSelector((state: Store) =>
    map(state.collegeEarnings.earnings, (earnings) => ({
      collegeId: earnings._id,
      slug: earnings.slug,
    }))
  );

  const communityCollegeInfo = useSelector((state: Store) => state.student.communityCollegeInfo);

  const followedCollegesTransferTerms = useSelector(
    (state: Store) => state.student.followedCollegesTransferTerms
  );

  const followedCollegesNextTransferTerms = useSelector(
    (state: Store) => state.student.followedCollegesNextTransferTerms
  );

  const transferSemester = get(communityCollegeInfo, 'transferSemester', '').toLowerCase();

  const notOfferedCollegeTransferTerms = filter(
    followedCollegesTransferTerms,
    (college) => !includes(college.transferTerms, transferSemester)
  );

  const handleCloseModal = () => {
    dispatch(closeModal(COLLEGES_NOT_OFFERING_TRANSFER_TERM_MODAL));
  };

  const collegesWithTerms = () =>
    map(notOfferedCollegeTransferTerms, (college) => {
      const logo =
        filter(collegeLogos, (collegeLogo) => college.collegeId === collegeLogo.collegeId)[0] || {};

      const collegeTermData =
        filter(
          followedCollegesNextTransferTerms,
          (collegeData) => collegeData.collegeId === college.collegeId
        )[0] || {};

      return (
        <div className="deferred-college" key={college.collegeId}>
          <span className="college-name">
            <img
              className="college-earnings-earning-image"
              alt={`${college.collegeName} logo`}
              src={`//colleges-static.raise.me/${logo.slug}/logo-120x120.png`}
            />
            {college.collegeName}
          </span>
          <span className="transfer-term">
            {capitalize(collegeTermData.transferTerm)} {collegeTermData.transferYear}
          </span>
        </div>
      );
    });

  return (
    <Modal show={show} onClose={handleCloseModal}>
      <Modal.TextHeader
        onClose={handleCloseModal}
        subtitle={`${communityCollegeInfo?.transferSemester} Transfer Term not offered at these colleges. The earnings deadlines for the
                    next available transfer term will apply.`}
      >
        Colleges not offering {communityCollegeInfo?.transferSemester} Transfer Terms
      </Modal.TextHeader>

      <div className="colleges-not-offering-transfer-term-modal">
        <Modal.Body>
          <div className="college-transfer-header">
            <span>College</span>
            <span className="transfer-date">Next Transfer Term</span>
          </div>
          <div className="college-transfer-terms">{collegesWithTerms()}</div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default CollegesNotOfferingTransferTermModal;
